export const STORAGE_NAME = 'personal_area';
export const STORAGE_JWT_KEY = 'jwt_token';
export const STORAGE_CODE_EXPIRED_KEY = 'code_expired';
export const STORAGE_PHONE_KEY = 'phone';
